import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title6", component(opts));
  editor.BlockManager.add("title6", block(opts));
};